import { MESSAGE_SENDER } from 'consts/enum';
import { ENGT_CHAT } from 'js/bot.model';
import './avatar.scss';

export const AvatarTemplate = (model) => {
	const { id, img, size, altText, title } = model;
	let animationCss = 'engt-avatar-wrapper-animation';
	const prevSender = ENGT_CHAT.get('lastMessageDetails')?.sender;
	if (prevSender === MESSAGE_SENDER.BOT || prevSender === MESSAGE_SENDER.AGENT) {
		animationCss = 'engt-avatar-wrapper-animation-bot';
	}

	/* html */
	const imgHtml =
		img &&
		`<img src="${img}" alt="${altText}" class="engt-avatar-icon" width="100%" height="100%" loader="lazy"></img>`;

	/* html */
	const html = `<div class="engt-avatar-wrapper ${animationCss}" data-avatar-id=${id} style="width: ${size}; height: ${size}; min-width: ${size}">${imgHtml}<span>${title}</span></div>`;

	return html;
};
